<div class="staff-wrapper">
  <h1>Bringing the best staff</h1>
  <div class="cards-wrapper">
    <div class="staff-card">
      <div class="img-wrap">
        <img src="../../assets/images/educators.svg" alt="logo" />
      </div>
      <h2>{{ school?.totalSpecial || "2" }} Special Educators</h2>
      <p>
        Our special educators provide personalized support to students with
        unique learning needs, fostering an inclusive environment.
      </p>
    </div>
    <div class="staff-card">
      <div class="img-wrap">
        <img src="../../assets/images/couns.svg" alt="logo" />
      </div>
      <h2>{{ school?.totalCounselor || "1" }} Wellness Counsellor</h2>
      <p>
        Our team of counsellors supports students’ emotional well-being and
        personal development.
      </p>
    </div>
    <div class="staff-card">
      <div class="img-wrap">
        <img src="../../assets/images/cards.svg" alt="logo" />
      </div>
      <h2>{{ school?.totalTeachers || "35" }}+ Teachers</h2>
      <p>
        With over 50 dedicated teachers, we offer expert instruction across a
        wide range of subjects.
      </p>
    </div>
  </div>
</div>
